module.exports = __webpack_public_path__ + "assets/img/farm_monitor1.4ca6328d.png";